import MainScenerCtrl from "./MainSceneCtrl";
import RTTScene from "./RTTScene";

const rttScene = new RTTScene({
  onLoadRoom: () => {
    // mainScene.onLoadRTTSceneRoom();
  },
});

rttScene.setScene();
rttScene.play();

const mainScene = new MainScenerCtrl();

mainScene.setScene();
mainScene.setRTTScene(rttScene);
mainScene.play();
